// extracted by mini-css-extract-plugin
module.exports = {"innerFormContainer":"AddRecipe_innerFormContainer__3ITvL","tittleContainer":"AddRecipe_tittleContainer__tQ9gM","buttonContainer":"AddRecipe_buttonContainer__3aJcR"};